/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
/* eslint-disable global-require */
import React, { useCallback, useEffect, useState } from 'react';
import { StyleSheet, Linking } from 'react-native';
import * as Analytics from 'expo-firebase-analytics';
import * as Progress from 'react-native-progress';
import { useIsFocused } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { v4 as uuidv4 } from 'uuid';
import Colors from '../../constants/Colors';
import MultiInputScreen from '../../components/survey/MultiInputScreen';
import SingleChoicePage from '../../components/survey/SingleChoicePage';
import IconButton from '../../components/elements/IconButton';
import MultiChoicePage from '../../components/survey/MultiChoicePage';
import DesiredWeightInputScreen from '../../components/survey/DesiredWeightInputScreen';
import SingleEntryScreen from '../../components/survey/SingleInputScreen';
import BreakScreen from '../../components/survey/BreakScreen';
import uploadSurveyResponsesUtil from '../../util';
import ProgressBarScreen from '../../components/survey/ProgressBarScreen';
import ValidationScreen from '../../components/survey/ValidationScreen';
import { RootStackScreenProps } from '../../navigation/navigationTypes';
import {
  ScreenFlow,
  ChoiceScreenProps,
  InfoEntryProps,
  BreakScreenProps,
  ValidationScreenProps,
  ProgressScreenProps,
} from '../../navigation/questionFlow';
import { Text, View } from '../../components/Themed';
import SnapCalorieSitePage from '../../components/SnapCalorieSitePage';

const END_OF_SURVEY_ID = 'END_OF_SURVEY';
const ScreenOrder = [...ScreenFlow.map((el) => el.id), END_OF_SURVEY_ID];

export default function ScreenManager({ navigation, route }: RootStackScreenProps<'Survey'>) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [questionNumber, setQuestionNumber] = useState<number>(() => {
    const requestedScreen = route.params ? route.params.id ?? ScreenOrder[0] : ScreenOrder[0];
    var index = ScreenFlow.map((object) => object.id).indexOf(requestedScreen);

    if (index === -1) {
      index = ScreenFlow.map((object) => object.id).indexOf(ScreenOrder[0]);
    }
    return index;
  });

  const [heightFt, setHeightFt] = useState<number | null>(null);
  const [heightIn, setHeightIn] = useState<number | null>(null);
  const [surveyResponses, setSurveyResponses] = useState<any>({});

  useEffect(() => {
    const updateResponses = async () => {
      const tempResponses = JSON.parse((await AsyncStorage.getItem(`@snapcalorie_survey_responses`)) ?? '{}');
      if (typeof tempResponses.id !== 'string') {
        tempResponses.id = uuidv4();
      }
      setSurveyResponses(tempResponses);
      uploadSurveyResponsesUtil(tempResponses);
    };
    updateResponses();
  }, []);

  useEffect(() => {
    const updateBmi = async () => {
      const currentHeightWeight = surveyResponses.CurrentHeightWeight ?? null;
      if (Array.isArray(currentHeightWeight) && currentHeightWeight.length > 0) {
        setHeightFt(currentHeightWeight[0]);
        setHeightIn(currentHeightWeight[1]);
      }
    };
    updateBmi();
  }, [surveyResponses.CurrentHeightWeight]);

  const [questionId, setQuestionId] = useState<string>(() => {
    const requestedScreen = route.params ? route.params.id ?? ScreenOrder[0] : ScreenOrder[0];
    return requestedScreen;
  });

  const isScreenActive = useIsFocused();

  const getNextQuestionUrl = useCallback((): string => {
    const requestedScreen = route.params ? route.params.id ?? ScreenOrder[0] : ScreenOrder[0];
    const index = ScreenOrder.indexOf(requestedScreen);
    return ScreenOrder[index + 1];
  }, [route.params]);

  const onSubmit = useCallback(
    (response: any) => {
      const saveResponsesAndGoToNextPage = async () => {
        const tmpObject = surveyResponses;
        tmpObject[questionId] = response;
        await AsyncStorage.setItem('@snapcalorie_survey_responses', JSON.stringify(tmpObject));
        const nextQuestion = getNextQuestionUrl();

        if (nextQuestion === END_OF_SURVEY_ID) {
          navigation.navigate('Checkout');
        } else {
          navigation.push('Survey', { id: nextQuestion });
        }
      };
      saveResponsesAndGoToNextPage();
    },
    [getNextQuestionUrl, navigation, questionId, surveyResponses]
  ); // prevents unnecessary renders

  const toWaitlist = useCallback(
    (response: any) => {
      const tmpObject = surveyResponses;
      tmpObject[questionId] = response;
      AsyncStorage.setItem('@snapcalorie_survey_responses', JSON.stringify(tmpObject));

      // setResponses(update(responses, { $push: [response] }));
      Analytics.logEvent('conversion-waitlist');
      if (window.gtag) {
        window.gtag('event', 'conversion', {
          send_to: 'AW-694660706/FRwaCJ6luYEYEOLcnssC',
        });
      }
      Linking.openURL('https://bit.ly/snapcalorie-homepage');
    },
    [questionId, surveyResponses]
  ); // prevents unnecessary renders

  const onReturn = useCallback(() => {
    // setResponses(update(responses, { $splice: [[responses.length - 1, 1]] }));
    console.log(ScreenFlow[questionNumber - 1]);
    if (questionNumber > 0) {
      navigation.goBack();
    }
  }, [navigation, questionNumber]);

  // If the screen is not currently focused, return an empty view
  if (!isScreenActive) {
    return <View />;
  }

  var currentScreen;
  if (ScreenFlow[questionNumber].type === 'SingleChoice') {
    // eslint-disable-next-line prettier/prettier
    const ScreenOptions = ScreenFlow[questionNumber] as ChoiceScreenProps;
    currentScreen = (
      <SingleChoicePage
        onSubmit={onSubmit} // pass function pointer to function onSubmit
        prompts={ScreenOptions.prompts}
        options={ScreenOptions.options}
        questionCategory={ScreenFlow[questionNumber].questionCategory}
      />
    );
  } else if (ScreenFlow[questionNumber].type === 'MultiChoice') {
    const ScreenOptions = ScreenFlow[questionNumber] as ChoiceScreenProps;
    currentScreen = (
      <MultiChoicePage
        onSubmit={onSubmit} // pass function pointer to function onSubmit
        prompts={ScreenOptions.prompts}
        options={ScreenOptions.options}
        questionCategory={ScreenFlow[questionNumber].questionCategory}
      />
    );
  } else if (ScreenFlow[questionNumber].type === 'MultiEntry') {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const ScreenOptions = ScreenFlow[questionNumber] as InfoEntryProps;
    currentScreen = (
      <MultiInputScreen
        questionCategory={ScreenFlow[questionNumber].questionCategory}
        onSubmit={onSubmit}
        title={ScreenOptions.title}
      />
    );
  } else if (ScreenFlow[questionNumber].type === 'DesiredWeightInputScreen') {
    const ScreenOptions = ScreenFlow[questionNumber] as InfoEntryProps;
    currentScreen = (
      <DesiredWeightInputScreen
        questionCategory={ScreenFlow[questionNumber].questionCategory}
        onSubmit={onSubmit}
        title={ScreenOptions.title}
        enteredFeet={heightFt ?? 5}
        enteredInch={heightIn ?? 10}
        label={ScreenOptions.label}
      />
    );
  } else if (ScreenFlow[questionNumber].type === 'SingleEntry') {
    const ScreenOptions = ScreenFlow[questionNumber] as InfoEntryProps;
    currentScreen = (
      <SingleEntryScreen
        questionCategory={ScreenFlow[questionNumber].questionCategory}
        onSubmit={onSubmit}
        title={ScreenOptions.title}
        label={ScreenOptions.label}
        keyboardType={ScreenOptions.keyboardType ?? 'numeric'}
        validationFunc={ScreenOptions.validationFunc}
      />
    );
  } else if (ScreenFlow[questionNumber].type === 'BreakScreen') {
    const ScreenOptions = ScreenFlow[questionNumber] as BreakScreenProps;
    currentScreen = (
      <BreakScreen
        questionCategory={ScreenFlow[questionNumber].questionCategory}
        blurb={
          ScreenOptions.blurbFunc ? ScreenOptions.blurbFunc(ScreenOptions.blurb, surveyResponses) : ScreenOptions.blurb
        }
        imageURL={ScreenOptions.imageURL}
        onSubmit={onSubmit}
        header={ScreenOptions.header}
      />
    );
  } else if (ScreenFlow[questionNumber].type === 'ProgressBar') {
    const ScreenOptions = ScreenFlow[questionNumber] as ProgressScreenProps;
    currentScreen = (
      <ProgressBarScreen
        questionCategory={ScreenFlow[questionNumber].questionCategory}
        blurb={ScreenOptions.blurb}
        duration={ScreenOptions.duration}
        onSubmit={onSubmit}
      />
    );
  } else if (ScreenFlow[questionNumber].type === 'ValidationScreen') {
    const ScreenOptions = ScreenFlow[questionNumber] as ValidationScreenProps;
    currentScreen = (
      <ValidationScreen
        blurb={ScreenOptions.blurb}
        imageURL={ScreenOptions.imageURL}
        textField={ScreenOptions.textField}
        onSubmit={onSubmit}
        toWaitlist={toWaitlist}
      />
    );
  }
  const progress = ScreenOrder.indexOf(questionId) / (ScreenOrder.length - 1);
  return (
    <SnapCalorieSitePage headerLinks={{}} showNavBar={false}>
      <View style={styles.page}>
        {questionNumber >= 0 && (
          <View style={styles.progressContainer}>
            <View style={[{ flexDirection: 'row' }]}>
              <View style={[{ width: 20 }]}>
                <IconButton
                  icon="arrowleft"
                  onPress={() => {
                    onReturn();
                  }}
                />
              </View>
              <Text
                style={[
                  styles.categoryLabel,
                  {
                    color: Colors.snapCalorie.buttonBlue,
                  },
                ]}
              >
                {ScreenFlow[questionNumber].questionCategory}
              </Text>
              <View style={[{ width: 20 }]} />
            </View>
            <Progress.Bar
              color={Colors.snapCalorie.buttonBlue}
              progress={Math.floor(progress * ScreenOrder.length) / (ScreenOrder.length - 2)}
              height={9}
              width={345}
            />
          </View>
        )}
        {global.window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'auto',
        })}
        {currentScreen}
      </View>
    </SnapCalorieSitePage>
  );
}

const styles = StyleSheet.create({
  page: {
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
  },
  progressContainer: {
    flexDirection: 'column',
    marginVertical: 40,
    width: 345,
    height: 51.5,
  },
  categoryLabel: {
    flex: 1,
    alignSelf: 'center',
    textAlign: 'center',
    color: '#14181B',
    fontSize: 20,
    fontWeight: 'bold',
    letterSpacing: -0.29,
    lineHeight: 25,
    marginBottom: 3,
  },
});
